import React from "react";
import { contact, contactReasons } from "../data/redlandGolfContent";

export function ContactForm() {
  function handleSubmit(event) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const name = String(form.get("name") ?? "");
    const email = String(form.get("email") ?? "");
    const phone = String(form.get("phone") ?? "");
    const reason = String(form.get("reason") ?? "");
    const message = String(form.get("message") ?? "");
    const subject = encodeURIComponent(`Redland Golf inquiry: ${reason}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\nReason: ${reason}\n\nMessage:\n${message}`
    );

    window.location.href = `${contact.emailHref}?subject=${subject}&body=${body}`;
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
      <div className="form-grid">
        <label>
          Name
          <input name="name" type="text" autoComplete="name" required data-testid="contact-name-input" />
        </label>
        <label>
          Email
          <input name="email" type="email" autoComplete="email" required data-testid="contact-email-input" />
        </label>
        <label>
          Phone
          <input name="phone" type="tel" autoComplete="tel" data-testid="contact-phone-input" />
        </label>
        <label>
          Reason for contacting
          <select name="reason" defaultValue="General Question" data-testid="contact-reason-select">
            {contactReasons.map((reason) => (
              <option value={reason} key={reason}>
                {reason}
              </option>
            ))}
          </select>
        </label>
      </div>
      <label>
        Message
        <textarea name="message" rows={6} required data-testid="contact-message-input" />
      </label>
      <p className="form-note">
        This form opens your email app with the message prepared for Redland Golf &amp; Country Club.
      </p>
      <button className="button button-primary" type="submit" data-testid="contact-submit-button">
        Submit
      </button>
    </form>
  );
}
